module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nav', {
    staticClass: "navbar navbar-toggleable-md navbar-light bg-faded mb-3"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbarSupportedContent"
    }
  }, [_c('ul', {
    staticClass: "navbar-nav mr-auto"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('nav.home')) + "\n          ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'missionList'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-tasks",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('nav.missions')) + "\n          ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'missionSlotTemplateList'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('nav.missionSlotTemplates')) + "\n          ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'communityList'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-users",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('nav.communities')) + "\n          ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'userList'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('nav.users')) + "\n          ")])], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "navbar-nav"
  }, [(_vm.loggedIn) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: {
      'text-danger': _vm.unseenNotificationCount > 0, 'font-weight-bold': _vm.unseenNotificationCount > 0
    },
    attrs: {
      "to": {
        name: 'notificationList'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bell",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.unseenNotificationCount) + " " + _vm._s(_vm.$t('nav.notifications')) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'account'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('nav.account')) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.loggedIn) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link text-primary",
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-in",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('nav.login')) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link text-danger",
    attrs: {
      "to": {
        name: 'home'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.logout($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('nav.logout')) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle text-muted",
    attrs: {
      "id": "navbarLanguageDropdown",
      "href": "#",
      "data-toggle": "dropdown",
      "aria-expanded": "false"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.selectedLanguage)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "navbarLanguageDropdown"
    }
  }, [_c('a', {
    staticClass: "dropdown-item text-muted",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setLocale('en')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/img/flags/gb.png"
    }
  }), _vm._v(" English")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item text-muted",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setLocale('de')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/img/flags/de.png"
    }
  }), _vm._v(" Deutsch")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item text-muted",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setLocale('de-at')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/img/flags/at.png"
    }
  }), _vm._v(" Österreichisch")])])])])])], 1), _vm._v(" "), [_c('div', {
    staticClass: "container"
  }, [_c('b-alert', {
    attrs: {
      "variant": _vm.alertVariant,
      "dismissible": _vm.alertDismissible,
      "show": _vm.showAlert
    },
    on: {
      "dismissed": _vm.alertDismissed,
      "dismiss-count-down": _vm.alertDismissCountDown
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.alertMessage)
    }
  })]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.working),
      expression: "working"
    }]
  }, [_c('loading-overlay', {
    attrs: {
      "message": _vm.working
    }
  })], 1)], 1)], _vm._v(" "), _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('span', {
    staticClass: "text-muted small float-left"
  }, [_vm._v("\n            Copyright © 2017-" + _vm._s(_vm.year) + "\n            "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("slotlist.info")]), _vm._v(". " + _vm._s(_vm.$t('rights.reserved')) + ".\n          ")], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('span', {
    staticClass: "text-muted small float-right"
  }, [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v(_vm._s(_vm.$t('nav.about')))]), _vm._v(" |\n            "), _c('router-link', {
    attrs: {
      "to": "/imprint"
    }
  }, [_vm._v(_vm._s(_vm.$t('nav.imprint')))]), _vm._v(" |\n            "), _c('router-link', {
    attrs: {
      "to": "/privacy"
    }
  }, [_vm._v(_vm._s(_vm.$t('nav.privacy')))]), _vm._v(" |\n            "), _c('router-link', {
    attrs: {
      "to": "/api"
    }
  }, [_vm._v(_vm._s(_vm.$t('nav.api')))]), _vm._v(" |\n            "), _vm._m(2), _vm._v(" |\n            "), _vm._m(3)], 1)])])])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggler navbar-toggler-right",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbarSupportedContent",
      "aria-controls": "navbarSupportedContent",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col text-center"
  }, [_c('span', {
    staticClass: "text-muted small"
  }, [_vm._v("\n            Made with\n            "), _c('i', {
    staticClass: "fa fa-heart",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" by\n            "), _c('a', {
    attrs: {
      "href": "https://github.com/MorpheusXAUT"
    }
  }, [_vm._v("MorpheusXAUT")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://github.com/MorpheusXAUT/slotlist-frontend"
    }
  }, [_c('i', {
    staticClass: "fa fa-github"
  }), _vm._v(" Frontend")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://github.com/MorpheusXAUT/slotlist-backend"
    }
  }, [_c('i', {
    staticClass: "fa fa-github"
  }), _vm._v(" Backend")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12a5d04f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 477
// module chunks = 0